/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { newAxiosInstance } from '../api/common/baseRequest';
import { ConsumerColors } from '../style/colors';
import { ClientConfig } from '@shared/constants/clientConfig';

const baseUrl = `/api/internal/configs`;
const baseRequest = newAxiosInstance();

interface Config extends ClientConfig {
  colors: Partial<ConsumerColors>;
}

let CONFIG: Config;

export const getConfig = (): Config => CONFIG;

export const loadConfig = async () => {
  const { data } = await baseRequest.get(baseUrl);
  // TODO: get colors from backend
  CONFIG = { ...data, colors: {} };
};

export const getIsMobileEnabled = () => {
  const { isMobileEnabled } = getConfig();
  return isMobileEnabled;
};
